/**
 * World 6 — "Champion Road" (All, levels 51–60). ACT II OPENER — THE
 * REVEAL: the recurring cast walks the road (Mimi and Lulu on separate nodes,
 * post-split), Aggie confesses that Old Man Gray is the First Keeper is the
 * Soul-Eater, and he flees beyond the island's edge — kicking off the chase. Levels/caps stamped from World 6's band (51→60). Squads are mixed-element
 * (champions of every kind) so the world's `element` is 'All'. Finale boss (slot
 * 0) is Sumiya — the hollow echo of the First Champ (Talion is Clan Z's alone; Zip
 * holds its stolen shard at z15-n3). Many squads echo the
 * nicknames/true-names of earlier worlds (Mossheart, Hearth, Castor, …) as a
 * deliberate callback to the Guardians the player already remembered. Dialogue
 * voiced at Pokémon Red trainer complexity.
 */

import {
  node,
  giftNode,
  giftTracks,
  giftXp,
  rival,
  CAMPAIGN_XP_NORMAL,
  CAMPAIGN_XP_MINI_BOSS,
  CAMPAIGN_XP_ZONE_BOSS,
  BIREON,
  GORLY,
  RAY,
  SUMIYA,
  PEFAREON,
  PIKOTO,
  FERNAIL,
  SUIMON,
  AQUA,
  PINKY,
  YETI,
  DRAGO,
  HOTPAW,
  TALION,
  TORO,
  ZARICAT,
  TRIXON,
  type CampaignWorld,
} from './builders.js';
import { GIFT_SKILL_SUIKA } from '../cardShopConfig.js';
import {
  WORLD6_NODE_STORIES as S,
  WORLD6_ZONE_STORIES as Z,
  WORLD6_TAGLINE,
} from './stories/world6.js';

export const WORLD_6: CampaignWorld = {
  worldId: 'w6',
  name: 'Champion Road',
  element: 'All',
  featuredSpeciesId: SUMIYA,
  story: WORLD6_TAGLINE,
  locked: true,
  zones: [
    {
      zoneId: 'z15',
      name: 'Hero Road',
      element: 'All',
      story: Z['z15'],
      nodes: [
        node({
          nodeId: 'z15-n1',
          kind: 'normal',
          rivalName: 'Mimi',
          rivalTitle: 'Lass',
          ...S['z15-n1'],
          squad: [rival(GORLY, 'Moss'), rival(RAY, 'Bramble'), rival(SUMIYA, 'Bloom')],
          opponentCount: 1,
          xpReward: CAMPAIGN_XP_NORMAL,
          portraitSpeciesId: GORLY,
        }),
        giftNode({
          nodeId: 'z15-g1',
          giver: 'Road Walker',
          label: 'Trailside Gift',
          story: "An old walker resting in a statue's shade waves you over.",
          line: 'The road pays its walkers. Soul Shards! Take them.',
          reward: { tracks: giftTracks(PIKOTO) },
          portraitSpeciesId: PIKOTO,
        }),
        node({
          nodeId: 'z15-n2',
          kind: 'normal',
          rivalName: 'Lulu',
          rivalTitle: 'Lass',
          ...S['z15-n2'],
          squad: [rival(FERNAIL, 'Belle'), rival(SUIMON, 'Surge'), rival(AQUA, 'Spindrift')],
          opponentCount: 1,
          xpReward: CAMPAIGN_XP_NORMAL,
          portraitSpeciesId: FERNAIL,
        }),
        node({
          nodeId: 'z15-n3',
          kind: 'mini_boss',
          rivalName: 'Zip',
          rivalTitle: 'Clan Z',
          ...S['z15-n3'],
          squad: [rival(TALION, 'Dash'), rival(DRAGO, 'Bonfire'), rival(HOTPAW, 'Ember')],
          opponentCount: 2,
          xpReward: CAMPAIGN_XP_MINI_BOSS,
          portraitSpeciesId: TALION,
          soulSpeciesId: TALION,
        }),
        node({
          nodeId: 'z15-nw1',
          kind: 'normal',
          encounterKind: 'wild',
          rivalName: 'Zaricat',
          rivalTitle: 'Wild Suikamon',
          ...S['z15-nw1'],
          squad: [rival(ZARICAT, 'Emberclaw'), rival(TORO, 'Cinder'), rival(HOTPAW, 'Scorch')],
          opponentCount: 1,
          xpReward: CAMPAIGN_XP_NORMAL,
          portraitSpeciesId: ZARICAT,
        }),
        node({
          nodeId: 'z15-n4',
          kind: 'zone_boss',
          rivalName: 'Cliff',
          rivalTitle: 'Bird Keeper',
          ...S['z15-n4'],
          squad: [rival(TRIXON, 'Castor'), rival(TORO, 'Bolt'), rival(ZARICAT, 'Arc')],
          opponentCount: 1,
          xpReward: CAMPAIGN_XP_ZONE_BOSS,
          portraitSpeciesId: TRIXON,
        }),
      ],
    },
    {
      zoneId: 'z16',
      name: 'Keeper Hall',
      element: 'All',
      story: Z['z16'],
      nodes: [
        node({
          nodeId: 'z16-n1',
          kind: 'normal',
          rivalName: 'Vera',
          rivalTitle: 'Channeler',
          ...S['z16-n1'],
          squad: [rival(SUMIYA, 'Murmur'), rival(SUMIYA, 'Hollow'), rival(PIKOTO, 'Brier')],
          opponentCount: 2,
          xpReward: CAMPAIGN_XP_NORMAL,
          portraitSpeciesId: SUMIYA,
        }),
        giftNode({
          nodeId: 'z16-g1',
          giver: 'Old Champ',
          label: 'Training Charm',
          story: 'A retired champ leaning on a worn staff nods at you.',
          line: 'This charm helped me once. Now you.',
          reward: { xp: giftXp(5) },
          portraitSpeciesId: PIKOTO,
        }),
        node({
          nodeId: 'z16-n2',
          kind: 'normal',
          rivalName: 'Aggie',
          rivalTitle: 'Medium',
          ...S['z16-n2'],
          squad: [rival(SUIMON, 'Knell'), rival(PINKY, 'Palelight'), rival(YETI, 'Glacier')],
          opponentCount: 2,
          xpReward: CAMPAIGN_XP_NORMAL,
          portraitSpeciesId: SUIMON,
        }),
        node({
          nodeId: 'z16-n3',
          kind: 'normal',
          rivalName: 'Timmy',
          rivalTitle: 'Youngster',
          ...S['z16-n3'],
          squad: [rival(DRAGO, 'Forgeson'), rival(PIKOTO, 'Quench'), rival(HOTPAW, 'Bellow')],
          opponentCount: 2,
          xpReward: CAMPAIGN_XP_NORMAL,
          portraitSpeciesId: DRAGO,
        }),
        node({
          nodeId: 'z16-n5',
          kind: 'normal',
          rivalName: 'Zap',
          rivalTitle: 'Clan Z',
          ...S['z16-n5'],
          squad: [rival(PEFAREON, 'Shade'), rival(SUMIYA, 'Pocket'), rival(PIKOTO, 'Brier')],
          opponentCount: 3,
          xpReward: CAMPAIGN_XP_NORMAL,
          portraitSpeciesId: PEFAREON,
        }),
        node({
          nodeId: 'z16-nw1',
          kind: 'normal',
          encounterKind: 'wild',
          rivalName: 'Drago',
          rivalTitle: 'Wild Suikamon',
          ...S['z16-nw1'],
          squad: [rival(DRAGO, 'Cinderhide'), rival(GORLY, 'Boulder'), rival(PIKOTO, 'Thorn')],
          opponentCount: 2,
          xpReward: CAMPAIGN_XP_NORMAL,
          portraitSpeciesId: DRAGO,
        }),
        node({
          nodeId: 'z16-n4',
          kind: 'zone_boss',
          rivalName: 'Mirror Champ',
          rivalTitle: 'Face Champ',
          ...S['z16-n4'],
          squad: [rival(ZARICAT, 'Hollowface'), rival(TRIXON, 'Silver'), rival(AQUA, 'Glasskin')],
          opponentCount: 2,
          xpReward: CAMPAIGN_XP_ZONE_BOSS,
          portraitSpeciesId: ZARICAT,
        }),
      ],
    },
    {
      zoneId: 'z17',
      name: 'Far Marker',
      element: 'All',
      story: Z['z17'],
      nodes: [
        node({
          nodeId: 'z17-n1',
          kind: 'normal',
          rivalName: 'Old Keepers',
          rivalTitle: 'Old Keepers',
          ...S['z17-n1'],
          squad: [rival(PIKOTO, 'Pilgrim'), rival(GORLY, 'Vow'), rival(FERNAIL, 'Lantern')],
          opponentCount: 3,
          xpReward: CAMPAIGN_XP_NORMAL,
          portraitSpeciesId: PIKOTO,
        }),
        giftNode({
          nodeId: 'z17-g1',
          giver: 'Shrine Keeper',
          label: 'Soul Token',
          story: 'At the marker stone, a Keeper shrine waits for you.',
          line: 'The old road leaves a big handful of Soul Shards here. Take them!',
          reward: { tracks: giftTracks(SUMIYA, true), suika: GIFT_SKILL_SUIKA },
          portraitSpeciesId: PIKOTO,
        }),
        node({
          nodeId: 'z17-n2',
          kind: 'normal',
          rivalName: 'Lost Hero',
          rivalTitle: 'Lost Hero',
          ...S['z17-n2'],
          squad: [rival(TORO, 'Wanderer'), rival(SUIMON, 'Mist'), rival(DRAGO, 'Ashfall')],
          opponentCount: 3,
          xpReward: CAMPAIGN_XP_NORMAL,
          portraitSpeciesId: TORO,
        }),
        node({
          nodeId: 'z17-n3',
          kind: 'mini_boss',
          rivalName: 'Sadness',
          rivalTitle: "Sad Heart",
          ...S['z17-n3'],
          squad: [rival(BIREON, 'Sorrow'), rival(TRIXON, 'Loss'), rival(SUMIYA, 'Ache')],
          opponentCount: 3,
          xpReward: CAMPAIGN_XP_MINI_BOSS,
          portraitSpeciesId: BIREON,
        }),
        node({
          nodeId: 'z17-n4',
          kind: 'zone_boss',
          rivalName: 'First Champ',
          rivalTitle: "Champion Guardian",
          ...S['z17-n4'],
          squad: [rival(SUMIYA, 'First Champ'), rival(GORLY, 'Firstborn'), rival(FERNAIL, 'Firsttide')],
          opponentCount: 3,
          xpReward: CAMPAIGN_XP_ZONE_BOSS,
          portraitSpeciesId: SUMIYA,
          soulSpeciesId: SUMIYA,
        }),
      ],
    },
  ],
};
